import { 
    SET_ADVOCACY_MESSAGE_DELIVERED,
    SET_LAUNCH_PROACTIVE_ADVOCACY_FLAG
} from './actionTypes'

export function setAdvocacyMessageDelivered(stateLocation: string, value: boolean) {
    return {
        type: SET_ADVOCACY_MESSAGE_DELIVERED,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setLaunchProctiveFlag(stateLocation: string, value: boolean) {
    return {
        type: SET_LAUNCH_PROACTIVE_ADVOCACY_FLAG,
        payload: {
            stateLocation,
            value
        }
    }
}



// WEBPACK FOOTER //
// ./modules/advocacy/actions/actions.ts